import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { toast } from 'sonner';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { googleLogin } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');

      if (!sessionId) {
        navigate('/login');
        return;
      }

      try {
        await googleLogin(sessionId);
        toast.success('Signed in with Google!');

        // Check for stored intent
        const intent = localStorage.getItem('pfc_intent');
        const selectedPlan = localStorage.getItem('pfc_selected_plan');
        const selectedPool = localStorage.getItem('pfc_selected_pool');
        localStorage.removeItem('pfc_intent');
        localStorage.removeItem('pfc_selected_plan');
        localStorage.removeItem('pfc_selected_pool');

        if (intent === 'start_pool') {
          navigate(`/create-pool${selectedPlan ? `?plan=${selectedPlan}` : ''}`, { replace: true });
        } else if (intent === 'join_pool' && selectedPool) {
          navigate(`/pools/${selectedPool}/join`, { replace: true });
        } else {
          navigate('/pools', { replace: true });
        }
      } catch (err) {
        toast.error('Google sign-in failed. Please try again.');
        navigate('/login', { replace: true });
      }
    };

    processAuth();
  }, [googleLogin, navigate]);

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="text-center">
        <div className="animate-spin h-8 w-8 border-4 border-[#5b3cc4] border-t-transparent rounded-full mx-auto mb-4" />
        <p className="text-sm text-muted-foreground">Signing in with Google...</p>
      </div>
    </div>
  );
}
